import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';

@Component({
    selector: 'app-individuals',
    templateUrl: './individuals.component.html',
    styleUrls: ['./individuals.component.scss']
})
export class IndividualsComponent implements OnInit {

  title = "Investing for Catholics Services for Individual Investors.";

  constructor(private seoservice: SeoService, private meta: Meta) { }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'catholic investment advice, catholic financial planning advice, catholic retirement planning advice, catholic charitable giving'});
    this.meta.addTag({name: 'description', content: 'Investing for Catholics Services for Individual Investors include investment advice, financial planning, retirement planning and other services.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
